import React, {Component} from "react";

export default class IndexVelocityMethod extends Component {
    render() {
        return <div>
            <span>
                Index Velocity Method
            </span>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/Hydrology/IndexVelocityMethod.js